export const locale = {
	lang: 'pt',
	data: {
		menu_pwa: 'PWAs',
		
		my_companies_header_navbar: 'As minhas empresas',
		companies_search: 'Digite para pesquisar',

		language_header_navbar: 'Idiomas',
		theme_mode_header_navbar: 'Modo do tema',
		account_manage_header_navbar: 'Gerir conta',
		sign_out_header_navbar: 'Terminar sessão',
		light_mode_header_navbar: 'Claro',
		dark_mode_header_navbar: 'Escuro',
		system_mode_header_navbar: 'Sistema',
		add_company_header_navbar: 'Empresa',

		en_EN: 'Inglês',
		fr_FR: 'Francês',
		es_ES: 'Espanhol',
		pt_PT: 'Português',

		drawer_back: 'Voltar',
		drawer_create: 'Criar',
		drawer_update: 'Atualizar',

		paginator_showing: 'A mostrar',
		paginator_items: 'itens',
		paginator_of: 'de',

		you_are_about_to_delete: 'Está prestes a eliminar {{typeTitle}} {{itemName}}!',
		once_deleted: 'Uma vez eliminado, este item não pode ser recuperado.',
		are_you_sure: 'Tem a certeza de que quer eliminar?',
		cancel: 'Cancelar',
		i_want_to_delete: 'Quero eliminar',

		the_company_will_no_longer: 'A empresa deixará de estar listada. Todos os dados da empresa serão eliminados.',
		create_a_company: 'Criar a sua empresa',
		create_company_information: 'Informações da empresa',
		create_company_information_description: 'Por favor, forneça as informações comerciais sobre a sua empresa. Para fins de faturação, preste atenção a todos os campos marcados com *.',

		create_company_form_label_name: 'Nome',
		create_company_form_label_legal_name: 'Nome legal',
		create_company_form_label_vat: 'NIF',
		create_company_form_label_email: 'E-mail',
		create_company_form_label_city: 'Cidade',
		create_company_form_label_country: 'País',
		create_company_form_label_address: 'Morada',
		create_company_form_label_zipcode: 'Código postal',
		create_company_form_label_phone: 'Telefone de contacto',
		create_company_form_label_website: 'Website',

		create_company_form_label_name_placeholder: 'Ex.: ABC Corporation',
		create_company_form_label_legal_name_placeholder: 'Ex.: ABC Holdings Ltd.',
		create_company_form_label_vat_placeholder: 'Ex.: 123456789',
		create_company_form_label_email_placeholder: 'Ex.: contacto@empresa.com',
		create_company_form_label_city_placeholder: 'Ex.: Lisboa',
		create_company_form_label_country_placeholder: 'Ex.: Portugal',
		create_company_form_label_address_placeholder: 'Ex.: 123 Parque empresarial, Rua principal',
		create_company_form_label_zipcode_placeholder: 'Ex.: 1000-001',
		create_company_form_label_phone_placeholder: 'Ex.: +351 21 234 5678',
		create_company_form_label_website_placeholder: 'Ex.: https://www.empresa.com',
		create_company_form_label_name_error: 'O nome é obrigatório',
		create_company_form_label_legal_name_error: 'O nome legal é obrigatório',
		create_company_form_label_vat_error: 'O número de NIF é obrigatório',
		create_company_form_label_email_error: 'O e-mail é obrigatório',

		create_webhook_address_cancelation: 'Endereço Webhook de cancelamento',
		create_webhook_address_confirmation: 'Endereço Webhook de confirmação',
		create_webhook_address_sale: 'Endereço Webhook de venda',
		create_webhook_address_cancelation_placeholder: 'Insira o endereço webhook de cancelamento',
		create_webhook_address_confirmation_placeholder: 'Insira o endereço webhook de confirmação',
		create_webhook_address_sale_placeholder: 'Insira o endereço webhook de venda',

		create_company_form_click_here_select_logotype: 'Clique aqui para selecionar o logótipo',
		create_company_form_click_here_select_cover_image: 'Clique aqui para selecionar a imagem de capa',

		edit_company_page_title: 'Informações da empresa',
		edit_company_page_description: 'Edite as informações da sua empresa',

		create_company_save_company: 'Guardar',

		table_head_label_name: 'Nome',
		table_head_label_priority: 'Prioridade',
		table_head_label_status: 'Estado',
		table_head_label_actions: 'Ações',
		table_head_label_start: 'Data de início',
		table_head_label_end: 'Data de fim',
		table_head_label_type: 'Tipo',
		table_head_label_gateways: 'Gateways',
		table_head_label_payment_methods: 'Métodos de pagamento',
		table_head_label_store_name: 'Loja',
		table_head_label_amount: 'Quantia',
		table_head_label_start_date: 'Data de início',
		table_head_label_final_date: 'Data de fim',
		table_head_label_date: 'Data',
		table_head_label_gateway: 'Gateway',
		table_head_label_payment_method: 'Método de pagamento',
		table_head_label_validity: 'Validade',
		table_head_label_stores: 'Lojas',
		table_head_label_company_name: 'Empresa',
		table_head_label_legal_name: 'Nome legal',
		table_head_label_role: 'Função',
		table_head_label_active: 'Ativo',

		active_company_header_navbar: 'Empresa ativa',
		active_company_informations_header_navbar: 'Informações da empresa',
		active_company_users_header_navbar: 'Gestão de utilizadores',
		active_company_roles_header_navbar: 'Funções de utilizador',

		company_user_management_page_title: 'Gestão de utilizadores',
		company_user_management_page_description: 'Gerir utilizadores associados à sua empresa',
		company_user_management_send_invite: 'Enviar convite',

		toast_user_role_updated: 'Função do utilizador atualizada com sucesso',
		toast_error_updating_user_role: 'Ocorreu um erro ao atualizar a função',

		toast_error_no_grant: 'Não tem permissão para realizar esta ação',

		company_roles_page_title: 'Funções',
		company_roles_page_description: 'Informações sobre as funções de utilizador associadas à empresa',
		company_role_create_role: 'Adicionar função',

		invite_user_drawer_title: 'Convidar utilizador',
		invite_user_drawer_description: 'Convide um novo utilizador para se juntar à empresa preenchendo o formulário abaixo.',
		invite_user_drawer_email: 'E-mail',
		invite_user_drawer_email_placeholder: 'E-mail do utilizador',
		invite_user_email_error: 'O e-mail é obrigatório',
		invite_user_drawer_role: 'Função do utilizador',
		select_role_placeholder: 'Selecionar uma função',
		send_invitation: 'Enviar convite',

		invitation_sent_successfully: 'Convite enviado com sucesso',
		error_sending_invitation: 'Ocorreu um erro ao enviar o convite',

		the_user: 'o utilizador',
		the_user_will_be_removed: 'O utilizador será removido da empresa e deixará de ter acesso aos seus recursos.',
		toast_user_role_deleted: 'O utilizador foi removido',
		toast_error_deleting_user_role: 'Ocorreu um erro ao remover o utilizador',
		toast_user_role_not_been_deleted: 'O utilizador não foi removido.',

		create_role_drawer_title: 'Criar uma função',
		create_role_drawer_description: 'Preencha o formulário para criar a função. Todos os campos devem ser preenchidos. Os campos marcados com * são obrigatórios.',
		create_role_drawer_label_name: 'Nome',
		create_role_drawer_label_actions: 'Ações',
		create_role_drawer_label_invites: 'Convites',
		create_role_drawer_label_resource: 'Recursos',
		create_role_drawer_label_active: 'Ativo',
		create_role_drawer_label_permissions: 'Permissões',
		create_role_drawer_label_company: 'Empresas',
		create_role_drawer_label_role: 'Funções',
		create_role_drawer_label_users: 'Utilizadores',
		create_role_drawer_label_create: 'Criar',
		create_role_drawer_label_read: 'Ler',
		create_role_drawer_label_update: 'Atualizar',
		create_role_drawer_label_delete: 'Eliminar',
		create_role_drawer_label_name_placeholder: 'Nome da função',
		create_role_drawer_label_api_keys: 'Chaves de acesso API',
		toast_role_created: 'A função foi criada.',
		toast_error_creating_role: 'Ocorreu um erro ao criar a função.',
		toast_role_updated: 'A função foi atualizada.',
		toast_error_updating_role: 'Ocorreu um erro ao atualizar a função.',
		toast_role_status_updated: 'O estado da função foi atualizado.',
		toast_error_updating_role_status: 'Ocorreu um erro ao atualizar o estado da função.',
		toast_role_not_updated: 'A função não foi atualizada.',
		toast_role_not_created: 'A função não foi criada.',
		toast_role_deleted: 'A função foi eliminada.',
		toast_error_deleting_role: 'Ocorreu um erro ao eliminar a função.',
		toast_role_not_been_deleted: 'A função não foi eliminada.',
		the_role: 'a função',
		the_role_will_be_removed: 'A função será removida de todos os locais onde está a ser utilizada.',

		pwa_page_title: 'PWA',
		pwa_page_description: 'Editar as suas PWA',
		pwa_create_pwa: 'Criar PWA',
		toast_status_pwa_changed: 'Estado da PWA alterado',
		toast_error_changing_pwa_status: 'Erro ao alterar o estado da PWA',

		edit_pwa_drawer_title: 'Editar PWA',
		create_pwa_drawer_title: 'Criar PWA',
		create_edit_pwa_drawer_description: 'Criar ou editar a sua PWA',
		create_pwa_form_label_name: 'Nome da PWA',
		create_pwa_form_label_image: 'Imagem',
		create_pwa_form_label_luope_id: 'ID Luope',
		create_pwa_form_label_shared_key: 'Chave partilhada',
		create_pwa_form_label_subdomain: 'Subdomínio',
		create_pwa_form_label_theme: 'Tema',

		create_pwa_form_placeholder_name: 'Inserir nome',
		create_pwa_form_placeholder_luope_id: 'Inserir ID Luope',
		create_pwa_form_placeholder_shared_key: 'Inserir chave partilhada',
		create_pwa_form_placeholder_subdomain: 'Inserir subdomínio',
		create_pwa_form_placeholder_theme: 'Inserir tema',
		update_pwa: 'Atualizar PWA',
		create_pwa: 'Criar PWA',
		toast_pwa_created: 'PWA criada com sucesso',
		toast_error_creating_pwa: 'Ocorreu um erro ao criar a PWA',
		toast_pwa_updated: 'PWA atualizada com sucesso',
		toast_error_updating_pwa: 'Ocorreu um erro ao atualizar a PWA',

		toast_error_loading_pwa: 'Erro ao carregar as PWA',
		toast_pwa_not_been_deleted: 'A PWA não foi eliminada',
		toast_error_deleting_pwa: 'Ocorreu um erro ao eliminar a PWA',
		toast_pwa_deleted: 'PWA eliminada com sucesso',
		invalid_json_format: 'Formato inválido para este campo',

		error_required_field: 'Este campo é obrigatório',

		menu_files: 'Ficheiros',
		sidebar_more: 'Mais',
		company_files_page_title: 'Ficheiros',
		company_files_page_description: 'Carregar e gerir os seus ficheiros',
		company_files_create_file: 'Ficheiro',

		create_loading_file_drawer_title: 'Carregamento de ficheiro',
		create_loading_file_drawer_description: 'Acompanhar o progresso dos seus ficheiros',
		create_loading_file_drawer_upload: 'Escolher ficheiros',

		select_files_drawer_title: 'Seleção de ficheiros',
		select_files_drawer_description: 'Selecionar os ficheiros para integrar na empresa, loja e/ou produtos da loja',

		toast_files_created: 'Os ficheiros foram carregados.',
		toast_files_created_error: 'Ocorreu um erro ao carregar os ficheiros',
		toast_files_tried_upload_not_accepted: 'Os ficheiros que tentou carregar não são aceites. Apenas serão aceites ficheiros jpeg, jpg, svg ou png.',
		toast_file_deleted: 'O ficheiro foi eliminado.',
		toast_error_deleting_file: 'Ocorreu um erro ao eliminar um ficheiro.',
		toast_file_not_been_eliminated: 'O ficheiro não foi eliminado.',

		the_file: 'o ficheiro',
		the_file_will_be_removed: 'O ficheiro será removido de todos os locais onde está a ser utilizado.',

		toast_error_company_files: 'Ocorreu um erro ao carregar os ficheiros',
		toast_error_server: 'Ocorreu um erro ao ligar ao servidor. Por favor, tente novamente.',

		toast_company_created: 'A empresa foi criada com sucesso.',
		toast_error_creating_company: 'Ocorreu um erro ao criar a empresa.',
		toast_info_file_selected: 'Ficheiro selecionado.',
		toast_company_eliminated: 'A empresa foi removida com sucesso.',
		toast_error_deleting_company: 'Ocorreu um erro ao eliminar a empresa.',
		toast_company_not_been_eliminated: 'A empresa não foi removida com sucesso.',
		toast_company_updated: 'A empresa foi atualizada com sucesso.',
		toast_error_updating_company: 'Ocorreu um erro ao atualizar a empresa.',
		the_pwa_will_be_removed: 'A PWA será removida.',
		the_pwa: 'A PWA',
		location_not_authrozied_warning: 'As permissões de localização não foram concedidas.',

		create_pwa_form_label_final_message: 'Mensagem de utilização da máquina',
		create_pwa_form_placeholder_final_message: 'Insira a mensagem de utilização da máquina',

		create_pwa_form_label_final_message_switch: 'Mostrar mensagem de utilização da máquina',
		create_pwa_form_label_logo: 'Logótipo da PWA',
		create_pwa_form_label_cover: 'Capa da PWA',

		create_pwa_form_label_customization: 'Personalização',
		create_pwa_form_label_color: 'Cor',

		theme_primary_color: 'Cor primária',
		theme_secondary_color: 'Cor secundária',
		theme_background_color: 'Cor de fundo',
		theme_accent_color: 'Cor de destaque',
		theme_action_color: 'Cor de ação',
		theme_success_color: 'Cor de sucesso',
		theme_warning_color: 'Cor de aviso',
		theme_danger_color: 'Cor de perigo',
		theme_logo_cover_color: 'Cor da capa do logótipo',
		theme_primary_font_color: 'Cor principal da fonte',
		theme_secondary_font_color: 'Cor secundária da fonte',
		theme_btn_action_color: 'Cor do botão de ação',
		theme_btn_font_action_color: 'Cor do texto do botão de ação',
		theme_highlight_font_color: 'Cor do texto em destaque',

		theme_description_primary_color: 'A cor principal utilizada em toda a aplicação',
		theme_description_secondary_color: 'A cor secundária utilizada em toda a aplicação',
		theme_description_background_color: 'A cor de fundo da aplicação',
		theme_description_accent_color: 'A cor de destaque para realces',
		theme_description_action_color: 'A cor para elementos de ação do utilizador',
		theme_description_success_color: 'A cor para estados de sucesso',
		theme_description_warning_color: 'A cor para estados de aviso',
		theme_description_danger_color: 'A cor para estados de erro',
		theme_description_logo_cover_color: 'A cor da capa do logótipo',
		theme_description_primary_font_color: 'A cor principal do texto',
		theme_description_secondary_font_color: 'A cor secundária do texto',
		theme_description_btn_action_color: 'A cor dos botões de ação do utilizador',
		theme_description_btn_font_action_color: 'A cor do texto dos botões de ação do utilizador',
		theme_description_highlight_font_color: 'A cor do texto em destaque',

		reset_theme: 'Repor tema',
	}
};
